import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import "./Login.css";
import Swal from "sweetalert2";

// Tarjeta centrada y sencilla: logo + formulario. La lógica de acceso no cambió.
const LoginShell = ({ children }) => (
  <div className="login-shell">
    <div className="login-card">
      <div className="text-center">
        <img src={process.env.PUBLIC_URL + "/logoInstitucion.png"} alt="logo" className="login-logo" />
      </div>
      {children}
    </div>
    <a href="https://lynqro.com" className="login-powered">
      Powered by <img src={process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png"} alt="Lynqro" />
    </a>
  </div>
);

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verPassword, setVerPassword] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const { loginUser } = useContext(AuthContext);
  const history = useHistory();
  const [loading] = useState(true);
  const [estadoPago, setEstadoPago] = useState("Activo");

  // Corriente: Activo
  // Antes del 10: Aviso
  // Moroso: Suspendido

  function handleClick() {
    history.push("/Inicio");
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const jsonSend = {
      email,
      password,
    };
    const LOGIN_URL = process.env.REACT_APP_URL_LOGIN;
    setEnviando(true);
    try {
      const res = await axios.post(LOGIN_URL, jsonSend);
      loginUser(res.data.token);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Bienvenido",
        showConfirmButton: false,
        timer: 2000,
      });
      handleClick();
    } catch (error) {
      setEnviando(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? error.response.data : error.message}`,
      });
      console.log(error);
    }
  };

  const formulario = (
    <Form onSubmit={handleSubmit}>
      <h2 className="login-title">Inicia sesión</h2>
      <p className="login-subtitle">Ingresa con tu correo y contraseña</p>
      <FormGroup>
        <Label>Email</Label>
        <div className="login-input">
          <i className="fas fa-envelope" />
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            placeholder="Escribe tu email"
            autoComplete="username"
            required
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label>Password</Label>
        <div className="login-input">
          <i className="fas fa-lock" />
          <Input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={verPassword ? "text" : "password"}
            placeholder="Escribe tu contraseña"
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            className="login-eye"
            onClick={() => setVerPassword(!verPassword)}
            title={verPassword ? "Ocultar" : "Mostrar"}
          >
            <i className={verPassword ? "fas fa-eye-slash" : "fas fa-eye"} />
          </button>
        </div>
      </FormGroup>
      <Button color="primary" className="login-submit" disabled={enviando}>
        {enviando ? <i className="fas fa-spinner fa-spin" /> : <i className="fas fa-sign-in-alt" />} Login
      </Button>
    </Form>
  );

  return (
    <LoginShell>
      {estadoPago === "Aviso" ? (
        loading ? (
          <div className="text-center">
            <div className="login-alert login-alert-warning"><i className="fas fa-exclamation-triangle" /></div>
            <h2 className="login-title">Aviso</h2>
            <p className="login-subtitle" style={{ fontSize: "0.9rem" }}>
              Te recordamos que para mantener tu servicio activo, es importante que te pongas al corriente
              con tus pagos antes del día 10. Si necesitas apoyo o tienes alguna duda, estamos aquí para ayudarte.
            </p>
            <Button color="danger" className="mt-3" onClick={() => setEstadoPago("")}>
              Cerrar
            </Button>
          </div>
        ) : (
          formulario
        )
      ) : estadoPago === "Suspendido" ? (
        <div className="text-center">
          <div className="login-alert login-alert-danger"><i className="fas fa-lock" /></div>
          <h2 className="login-title" style={{ color: "#b91c1c" }}>Saldo Pendiente</h2>
          <p className="login-subtitle">
            Notamos que tienes un saldo pendiente en tu cuenta. Para continuar con el acceso, te invitamos
            a regularizarlo lo antes posible.
          </p>
          <p className="login-subtitle">Si necesitas más información o ayuda con tu pago, contáctanos.</p>
          <p className="login-subtitle">Gracias por tu comprensión.</p>
        </div>
      ) : (
        formulario
      )}
    </LoginShell>
  );
};

export default Login;
